export const C = {
  green: "#0F6E56",
  text: "#0E1F19",
  cream: "#FAF8F3",
  mint: "#EAF3EC",
  gold: "#B08D3F",
};

export const AREAS = [
  { code: "A", name: "Marca empleadora" },
  { code: "B", name: "Selección y contratación" },
  { code: "C", name: "Onboarding" },
  { code: "D", name: "Evaluación del desempeño" },
  { code: "E", name: "Feedback y comunicación interna" },
  { code: "F", name: "Desarrollo profesional y retención" },
];

export const NIVELES = [
  { nivel: 1, label: "Crítico" },
  { nivel: 2, label: "En desarrollo" },
  { nivel: 3, label: "Funcional" },
  { nivel: 4, label: "Sólido" },
];

export const DOLOR_ROWS = [
  { band: "alto", label: "Dolor alto", idx: 2 },
  { band: "medio", label: "Dolor medio", idx: 1 },
  { band: "bajo", label: "Dolor bajo", idx: 0 },
];

export const ZONES = {
  "Arreglar ya": { bg: "#F8E1DC", fg: "#7A2E20" },
  Planificar: { bg: "#F6ECCB", fg: "#6B4A0B" },
  Mantener: { bg: "#DCEFE3", fg: "#0F5A44" },
};

export const zoneForScore = (s) => (s >= 4 ? "Arreglar ya" : s >= 2 ? "Planificar" : "Mantener");

export const PRIVACY_NOTE = "Escribe funciones, roles o situaciones, nunca nombres de personas.";

export const IMPACTO_OPTS = [
  { v: "alto", l: "Alto" },
  { v: "medio", l: "Medio" },
  { v: "bajo", l: "Bajo" },
];
export const RESPALDO_OPTS = [
  { v: "nadie", l: "Nadie más puede hacerla" },
  { v: "una", l: "Una persona más" },
  { v: "varias", l: "Varias personas" },
];
export const DOC_OPTS = [
  { v: "si", l: "Sí" },
  { v: "parcial", l: "Parcial" },
  { v: "no", l: "No" },
];

export const DEP_ZONES = {
  "Punto único de fallo": ZONES["Arreglar ya"],
  Atención: ZONES.Planificar,
  Cubierta: ZONES.Mantener,
};
export const depZoneForScore = (s) => (s >= 4 ? "Punto único de fallo" : s === 3 ? "Atención" : "Cubierta");

export const CONV_OPTS = [
  { v: "coincide", l: "Lo que he oído coincide con mi diagnóstico" },
  { v: "menos", l: "Es menos grave de lo que pensaba" },
  { v: "mas", l: "Es más grave de lo que pensaba" },
];

export const KIND_STYLES = {
  coincidencia: ZONES.Mantener,
  punto_ciego: ZONES["Arreglar ya"],
  falsa_alarma: ZONES.Planificar,
};

export const ONE_TO_ONE_NOTE = "Mantén conversaciones individuales regulares con todas las personas del equipo, no solo con quienes parezcan estar en riesgo.";

export const FRECUENCIA_OPTS = [
  { v: "frecuente", l: "Frecuente" },
  { v: "rara", l: "Rara" },
];
export const RIESGO_OPTS = [
  { v: "bajo", l: "Riesgo bajo" },
  { v: "alto", l: "Riesgo alto" },
];
export const DELEG_ZONES = {
  "Delegar ya": ZONES["Arreglar ya"],
  "Delegar con criterios escritos": ZONES.Planificar,
  "Delegar cuando surja": ZONES.Planificar,
  "Mantener tú": ZONES.Mantener,
};
export const DELEG_CELL = { "frecuente-bajo": "Delegar ya", "frecuente-alto": "Delegar con criterios escritos", "rara-bajo": "Delegar cuando surja", "rara-alto": "Mantener tú" };
